import React, { useState, useEffect, useRef } from "react";

import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

import Item from "./Item";
import questions from "../questions.json";

const Result = ({data}) => {
    const initialKey = {
        1: { Gift: "Leadership", ref: 1, tally: 0, baseScore: 0, color: "#619d8c", description: "Leadership aids the body by leading and directing members to accomplish the goals and purposes of the church. Leadership motivates people to work together in unity toward common goals (Romans 12:8)." },
        2: { Gift: "Administration", ref: 2, tally: 0, baseScore: 0, color: "#386260", description: "Persons with the gift of administration lead the body by steering others to remain on task. Administration enables the body to organize according to God-given purposes and long-term goals (1 Corinthians 12:28)." },
        3: { Gift: "Teaching", ref: 3, tally: 0, baseScore: 0, color: "#db8b7a", description: "Teaching is instructing members in the truths and doctrines of God’s Word for the purposes of building up, unifying, and maturing the body (1 Corinthians 12:28; Romans 12:7; Ephesians 4:11)." },
        4: { Gift: "Knowledge", ref: 4, tally: 0, baseScore: 0, color: "#d17250", description: "The gift of knowledge manifests itself in teaching and training in discipleship. It is the God-given ability to learn, know, and explain the precious truths of God’s Word. A word of knowledge is a Spirit-revealed truth (1 Corinthians 12:28)." },
        5: { Gift: "Wisdom", ref: 5, tally: 0, baseScore: 0, color: "#358386", description: "Wisdom is the gift that discerns the work of the Holy Spirit in the body and applies His teachings and actions to the needs of the body (1 Corinthians 12:28)." },
        6: { Gift: "Prophecy", ref: 6, tally: 0, baseScore: 0, color: "#aebdb1", description: "The gift of prophecy is proclaiming the Word of God boldly. This builds up the body and leads to conviction of sin. Prophecy manifests itself in preaching and teaching (1 Corinthians 12:10; Romans 12:6)." },
        7: { Gift: "Discernment", ref: 7, tally: 0, baseScore: 0, color: "#e29f91", description: "Discernment aids the body by recognizing the true intentions of those within or related to the body. Discernment tests the message and actions of others for the protection and well-being of the body (1 Corinthians 12:10)." },
        8: { Gift: "Exhortation", ref: 8, tally: 0, baseScore: 0, color: "#aa756f", description: "Possessors of this gift encourage members to be involved in and enthusiastic about the work of the Lord. Members with this gift are good counselors and motivate others to service. Exhortation exhibits itself in preaching, teaching, and ministry (Romans 12:8)." },
        9: { Gift: "Shepherding", ref: 9, tally: 0, baseScore: 0, color: "#5ca6ab", description: "The gift of shepherding is manifested in persons who look out for the spiritual welfare of others. Although pastors, like shepherds, do care for members of the church, this gift is not limited to a pastor or staff member (Ephesians 4:11)." },
        10: { Gift: "Faith", ref: 10, tally: 0, baseScore: 0, color: "#aba7a7", description: "Faith trusts God to work beyond the human capabilities of the people. Believers with this gift encourage others to trust in God in the face of apparently insurmountable odds (1 Corinthians 12:9)." },
        11: { Gift: "Evangelism", ref: 11, tally: 0, baseScore: 0, color: "#c2ab99", description: "God gifts his church with evangelists to lead others to Christ effectively and enthusiastically. This gift builds up the body by adding new members to its fellowship (Ephesians 4:11)." },
        12: { Gift: "Apostleship", ref: 12, tally: 0, baseScore: 0, color: "#a48d83", description: "The church sends apostles from the body to plant churches or be missionaries. Apostles motivate the body to look beyond its walls in order to carry out the Great Commission (1 Corinthians 12:28; Ephesians 4:11)." },
        13: { Gift: "Service/helping", ref: 13, tally: 0, baseScore: 0, color: "#477b96", description: "Those with the gift of service/helps recognize practical needs in the body and joyfully give assistance to meeting those needs. Christians with this gift do not mind working behind the scenes (1 Corinthians 12:28; Romans 12:7)." },
        14: { Gift: "Mercy", ref: 14, tally: 0, baseScore: 0, color: "#166054", description: "Cheerful acts of compassion characterize those with the gift of mercy. Persons with this gift aid the body by empathizing with hurting members. They keep the body healthy and unified by keeping others aware of the needs within the church (Romans 12:8)." },
        15: { Gift: "Giving", ref: 15, tally: 0, baseScore: 0, color: "#cab590", description: "Members with the gift of giving give freely and joyfully to the work and mission of the body. Cheerfulness and liberality are characteristics of individuals with this gift (Romans 12:8)." },
        16: { Gift: "Hospitality", ref: 16, tally: 0, baseScore: 0, color: "#8c6f65", description: "Those with this gift have the ability to make visitors, guests, and strangers feel at ease. They often use their home to entertain guests. Persons with this gift integrate new members into the body (1 Peter 4:9)." }
    };

    const contentRef = useRef();

        const generatePDF = async () => {
            const elementRef = contentRef.current;
            const element = elementRef.cloneNode(true);
            document.body.appendChild(element);
            element.style.position = 'fixed';
            element.style.top = '-9999px';
            element.style.left = '-9999px';
            element.classList.add("pdf-export")


            // Step 1: Render content to canvas
            const canvas = await html2canvas(element, {scale: 1, useCORS: true});
            const imgData = canvas.toDataURL('image/jpeg', 1);

            // Step 2: Calculate dimensions
            const imgWidth = 210; // A4 width in mm
            const pageHeight = 297; // A4 height in mm

            const pdf = new jsPDF('p', 'mm', 'a4');

            const imgProps = pdf.getImageProperties(imgData);
            const imgHeight = (imgProps.height * imgWidth) / imgProps.width;

            let heightLeft = imgHeight;
            let position = 0;

            // Step 3: Add image to PDF, slicing into pages if necessary
            while (heightLeft > 0) {
                pdf.addImage(imgData, 'JPEG', 0, 0, imgWidth, imgHeight);
                heightLeft -= pageHeight;

                if (heightLeft > 0) {
                    pdf.addPage();
                    // eslint-disable-next-line
                    position -= pageHeight;
                }
            }
            element.classList.remove("pdf-export")
            pdf.save('SpiritualGiftsSurveyResult.pdf');
            document.body.removeChild(element);
        };

   const [preparedGifts, setPreparedGifts] = useState([]);
   const [giftOpened, setGiftOpened] = useState(null);

    useEffect(() => {

        questions.Questions.forEach(question => {
            initialKey[question.rating].baseScore += 5;
        })

        setPreparedGifts([]);
        if (data.length > 0) {
            console.log('data', data);
            data.forEach((item) => {
                initialKey[item.rating].tally += item.vote;
            });

            setPreparedGifts(Object.keys(initialKey).map((key)=>initialKey[key]).sort((a, b) => b.tally - a.tally));

            console.log('prep', initialKey);
        }

        // const tempGifts = [];
        // Object.keys(initialKey).forEach((value, index) => {
        //     preparedGifts.push(initialKey[value]);
        // });
        //
        // console.log(data);
        // console.log('prep', preparedGifts);
    // eslint-disable-next-line
    }, [data]);

    return (
        giftOpened ?
            <div className={"gift-description"}>
                <h3>{initialKey[giftOpened].Gift}</h3>
                <p>{initialKey[giftOpened].description || "No description"}</p>
                <button className={"btn"} onClick={() => setGiftOpened(null)}>{"< Back to Results"}</button>
            </div>:
            <div className="results_main" ref={contentRef}>
              <h2>Survey Results </h2>
              <h3>How to interpret your results</h3>
              <p>
                This graph is based on your answers and can give an indication of your gifting. This survey is just the first step; now is the time to seek counsel and discover how your gifts can help build up the church.
              </p>
              {
                <>
                  <div className="results_box">
                      {
                          preparedGifts.map((item, index) => {
                             return <Item stuff={item} key={item.ref} setGiftOpened={setGiftOpened} />
                          })
                      }
                  </div>
                </>
              }
                <button className={'btn pdf-export-btn'} onClick={generatePDF}>Download Result as PDF</button>
            </div>

  );
};

export default Result;
